import { render, staticRenderFns } from "./customer-group.vue?vue&type=template&id=4f8054f7&scoped=true&"
import script from "./customer-group.vue?vue&type=script&lang=js&"
export * from "./customer-group.vue?vue&type=script&lang=js&"
import style0 from "./customer-group.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./customer-group.vue?vue&type=style&index=1&id=4f8054f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8054f7",
  null
  
)

export default component.exports